// Inline only when this fallback renders; healthy pages do not preload error-only styles.
export const classes = {
  "surface": "danaro-workspace-error__surface",
  "content": "danaro-workspace-error__content",
  "brand": "danaro-workspace-error__brand",
  "reference": "danaro-workspace-error__reference",
  "actions": "danaro-workspace-error__actions",
  "help": "danaro-workspace-error__help"
} as const

export const css = `
.danaro-workspace-error__surface {
  min-height: 65dvh;
  display: grid;
  align-items: center;
  padding: clamp(24px, 5vw, 64px);
  background: var(--background, #f7f7f8);
  color: var(--foreground, #171719);
  font-family: var(--font-inter, Arial), sans-serif;
}
.danaro-workspace-error__content { width: 100%; max-width: 620px; margin-inline: auto; }
.danaro-workspace-error__brand { font-size: 14px; font-weight: 600; margin: 0 0 24px; }
.danaro-workspace-error__content h1 { font-size: clamp(23px, 4vw, 30px); line-height: 1.25; letter-spacing: -.025em; margin: 0 0 16px; }
.danaro-workspace-error__content > p:not(.danaro-workspace-error__brand) { font-size: 14px; line-height: 1.65; opacity: .8; }
.danaro-workspace-error__reference { overflow-wrap: anywhere; }
.danaro-workspace-error__actions { display: flex; flex-wrap: wrap; align-items: center; gap: 10px; margin-block: 24px; }
.danaro-workspace-error__actions button, .danaro-workspace-error__actions a { min-height: 42px; display: inline-flex; align-items: center; justify-content: center; padding: 10px 16px; border: 1px solid var(--border, #d7d7da); border-radius: 10px; font: inherit; font-size: 13px; background: transparent; color: inherit; text-decoration: none; cursor: pointer; }
.danaro-workspace-error__actions button:first-child { color: var(--background, #fff); background: var(--foreground, #171719); border-color: transparent; }
.danaro-workspace-error__actions :focus-visible { outline: 2px solid currentColor; outline-offset: 3px; }
.danaro-workspace-error__content .danaro-workspace-error__help { font-size: 12px; }
@media (max-width: 480px) { .danaro-workspace-error__actions { align-items: stretch; flex-direction: column; } }
`
